import { MdAttachMoney, MdGroup } from 'react-icons/md';

import Widget from 'components/widget/Widget';
import UsersTable from 'views/admin/default/components/UsersTable';
import { useUsersStore } from 'views/store/useUsersStore';

const Dashboard = () => {
  const {
    totalUsers,
  } = useUsersStore();

  return (
    <div>
      <div className="mt-3 w-full flex md:flex-row gap-4 items-center">
        <div className="w-fit">
          <Widget
            icon={<MdGroup className="h-7 w-7" />}
            title={'Total users'}
            subtitle={
              !totalUsers ? 'Loading...' : totalUsers
            }
          />
        </div>
        {/* <div className="w-fit">
          <Widget
            icon={<MdAttachMoney className="h-7 w-7" />}
            title={'Total Revenue'}
            subtitle={
              129850
              // isLoading ? 'Loading...' : statistics?.totalUsersCount?.toString()
            }
          />
        </div> */}
      </div>
      <div className="mt-5 grid grid-cols-1 gap-5">
        <div className="w-full">
          <UsersTable />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
